import { Agent, AgentTracingMode } from '../../types/agentTypes'
import { axiosClient } from '../axiosClient'

export interface CreateAgentData {
  name: string
  description?: string
  profile_picture_url?: string
  type: string
  ai_model_id?: string
  department_id?: string
  job_category_id?: string
  tags?: string[]
  example_questions?: string[]
  system_prompt: string
  // Defines which tool the agent can use
  tools: ('FILE_SEARCH' | 'INTERNET_SEARCH')[]
  tracing_mode?: AgentTracingMode
}

export interface UpdateAgentData extends Partial<CreateAgentData> {
  id: string
}

export interface AgentContact {
  country: string
  name: string
  phone: string
  email: string
}

export interface AgentContactTable {
  contacts: AgentContact[]
}

export const agentFunctions = {
  fetchAgentsList: async (): Promise<Agent[]> => {
    return await axiosClient.get('api/agents/')
  },

  fetchAgent: async (agentId: string): Promise<Agent & { system_prompt?: string }> => {
    return await axiosClient.get(`api/agents/${agentId}/`)
  },

  createAgent: async (data: CreateAgentData): Promise<Agent> => {
    return await axiosClient.post('api/agents/', data)
  },

  updateAgent: async (data: UpdateAgentData): Promise<Agent> => {
    const { id, ...updateData } = data
    return await axiosClient.put(`api/agents/${id}/`, updateData)
  },

  deleteAgent: async (agentId: string): Promise<void> => {
    await axiosClient.delete(`api/agents/${agentId}/`)
  },

  updateAgentPreference: async (agentId: string, isPreferred: boolean): Promise<{ is_preferred: boolean }> => {
    return await axiosClient.put(`api/agents/${agentId}/preference/`, { is_preferred: isPreferred })
  },

  fetchAgentContacts: async (agentId: string): Promise<AgentContactTable> => {
    return await axiosClient.get(`api/agents/${agentId}/contacts/`)
  },

  createAgentContact: async (agentId: string, contact: AgentContact): Promise<AgentContact> => {
    return await axiosClient.post(`api/agents/${agentId}/contacts/`, contact)
  },

  updateAgentContact: async (agentId: string, country: string, contact: AgentContact): Promise<AgentContact> => {
    return await axiosClient.put(`api/agents/${agentId}/contacts/${country}/`, contact)
  },

  deleteAgentContact: async (agentId: string, country: string): Promise<void> => {
    await axiosClient.delete(`api/agents/${agentId}/contacts/${country}/`)
  },
}
